import Chip from '@mui/material/Chip';
import { Key } from 'react';
import IbssSvgIcon from '../../Icons/SvgIcon/IbssSvgIcon';

export default function IbssbreadcrumbLeft(props: { value: IBreadcrumbModel[]; }) 
{
  return (
  <>
  <div className='ibss-breadcrumb'>
      {props.value.map((data: IBreadcrumbModel, index: Key | null | undefined) => {
        let icon;
        if (typeof data.src === 'string') 
        {
          icon = <img alt={data.value} src={data.src} height="20px" />;
        } else 
        {
          icon = <IbssSvgIcon fontSize="small" sx={{mr: 2}}>{data.src}</IbssSvgIcon>;
        }

        return (
          <>
            <Chip
              icon={icon}
              label={data.value.toUpperCase()}
              sx={{marginRight: 3}}
              />
            </>
        );
      })}
    </div>
  </>
  );
}

export interface IBreadcrumbModel
{
    src: string | JSX.Element,
    value: string
}
